<div class="bg-white shadow-md rounded mt-6">
  <!-- <div
    (click)="
      decrementLevel(
        level >= 3
          ? getSelected(level3).title
          : level >= 2
          ? getSelected(level2).title
          : getSelected(level1).title
      )
    "
    class="text-center text-4xl text-red-500 font-bold cursor-pointer py-5"
  >
    <span *ngIf="level >= 3">{{ getSelected(level3).title + " - " }}</span>
    <span *ngIf="level >= 2">{{ getSelected(level2).title + " - " }}</span>
    <span *ngIf="level >= 1">{{ getSelected(level1).title }}</span>
    <span *ngIf="level == 0">Par année</span>
  </div> -->
  <!-- <div class="flex items-center justify-center overflow-auto p-8 gap-4">
    <div
      (click)="selectParentHeader(parentHeader)"
      *ngFor="let parentHeader of _level2"
      class="divansition-all"
      [class]="
        configs.parentHeadersClass +
        (parentHeader.selected
          ? ' ' + configs.parentHeadersClassSelected
          : ' bg-gray-200 text-gray-700')
      "
    >
      {{ parentHeader.title }}
    </div>
  </div> -->
  <div [class]="configs.tableClass">
    <div>
      <div class="flex justify-around" [class]="configs.headerClass">
        <div
          style="padding-right: 2px; min-width: 180px; max-width: 180px"
        ></div>
        <div
          *ngFor="let header of _level3; index as o"
          class="py-1 px-6 text-right w-1-6"
          [class]="hovredCol == o ? 'bg-gray-800 text-white' : ''"
        >
          {{ o == 0 && showAvant ? "Avant de" : "" }}
          <ng-container *ngIf="filterBy == 'day'">{{
            o == 0 && showAvant
              ? (header.title | date: " dd-MM-YYYY")
              : (header.title | date: "EEEE dd-MM-YYYY")
          }}</ng-container>
          <ng-container *ngIf="filterBy == 'mounth'"
            >{{ o == 1  && !isOne(header.title) && showAvant ? "Le reste de" : "" }}
            {{
              o == 0
                ? (header.title | date: "dd MMMM")
                : (header.title | date: "MMMM")
            }}</ng-container
          >
        </div>
      </div>
    </div>
    <div class="text-gray-600 text-sm font-light">
      <ng-container *ngFor="let row of dataSource; index as h">
        <div
          class="flex justify-between"
          [class]="
            (h % 2
              ? 'bg-gray-50 border-b border-gray-200 '
              : 'bg-white border-b border-gray-200 ') +
            configs.RowClass +
            ' ' +
            row.class
          "
          [style]="
            'background-color:' +
            row.backGroundColor +
            ';color:' +
            row.textColor +
            ';'
          "
        >
          <div
            (click)="row.expanded = expandCollapse(row.expanded)"
            class="pr-6 indent-2 py-1 whitespace-nowra font-bold w-1-6 flex items-center justify-between cursor-pointer"
            style="min-width: 180px; max-width: 180px"
          >
            <span class="text-left">{{ row.title }}</span>
            <span
              *ngIf="row.title!= 'Solde Initial' && row.title!= 'Total Mouvement' && row.title!= 'Solde Final' "
              class="float-right mr-2 text-sm"
              style="line-height: 1"
              >{{ row.expanded ? "▲" : "▼" }}</span
            >
          </div>
          <div
            *ngFor="let col of row.data; index as i"
            class="py-1 px-6 text-right whitespace-nowrap w-1-6"
            [class]="i == 0 ? 'border-r border-l  border-blue-500 ' : ''"
            [style]="i == 0 && hideFirstcol  ? 'content-visibility: hidden;' : ''"
          >
            {{ col | number: ".3-3":"fr" }}
          </div>
        </div>
        <ng-container  *ngFor="let childRow of row.childs;let r=index">
          <div
            class="flex justify-between"
            [class]="getChildClassStyles(h, childRow.class, row.expanded)"
            [style]="'background-color:' + childRow.backgroundColor"
            
          >
            <div
              (click)="toggleChildExpantion(row.childs, childRow)"
              [class]=" !row.expanded ? 'rowInvis' : 'py-1  opacity-100  '"
              class="indent-8 whitespace-nowra font-bold w-1-6 flex items-center justify-start cursor-pointer"
              style="min-width: 180px; max-width: 180px"
            >
              <div class="flex flex-col">
                <span>{{ childRow.title }}</span>
              </div>
              <span *ngIf="!hideExpand || childRow.show" class="float-right mr-2 text-sm" style="line-height: 1">{{
                childRow.expanded ? "▲" : "▼"
              }}</span>
            </div>
            <div
              [class]="
                !row.expanded
                  ? 'rowInvis'
                  : i == 0
                  ? 'border-r border-l  border-blue-500 py-1  opacity-100 w-1-6'
                  : 'py-1  opacity-100 w-1-6'
              "
              *ngFor="let childCol of childRow.data; index as i"
              class="px-6 text-right whitespace-nowrap" 
              [style]="i == 0 && hideFirstcol  ? 'content-visibility: hidden;' : ''"
            >
              {{ childCol | number: ".3-3":"fr" }}
            </div>
          </div>

          <div class="w-full overflow-auto">
            <ng-container *ngFor="let banks of childRow.childs; index as b">
              <div
                class="flex justify-between"
                [class]="b % 2 == 0 ? 'bg-gray-100 ' : ''"
              >
                <div
                  [class]="
                    !row.expanded || !childRow.expanded
                      ? 'rowInvis'
                      : 'py-1  opacity-100 ' + banks.class
                  "
                  class="indent-10 whitespace-nowra font-bold w-1-6"
                  style="min-width: 180px; max-width: 180px"
                  (click)="banks.expanded = !banks.expanded"
                >
                  {{ banks.title }}
                  <span *ngIf="!allowIcon"
                    class="float-right mr-5 text-sm"
                    style="line-height: 1"
                    >{{ banks.expanded  ? "▲" : "▼" }}</span
                  >
                </div>
                <div
                  [class]="
                    !row.expanded || !childRow.expanded
                      ? 'rowInvis'
                      : i == 0
                      ? h == 0
                        ? ' border-r border-l  border-blue-500 ' + banks.class
                        : 'echCol border-r border-l  border-blue-500' +
                          banks.class
                      : h == 0
                      ? 'py-1 opacity-100 w-1-6 ' + banks.class
                      : 'py-1 opacity-100 w-1-6 ' + banks.class
                  "
                  *ngFor="let detail of banks.data; index as i"
                  class="px-6 text-right whitespace-nowrap text-gray-800 font-bold w-1-6"
                  style="min-width: 150px"
                  [style]="i == 0 && hideFirstcol  ? 'content-visibility: hidden;' : ''"
                >
                  {{ detail | number: ".3-3":"fr" }}
                </div>
              </div>
              <ng-container *ngFor="let details of banks.details; index as j">
                <div
                  class="w-full overflow-auto"
                  [class]="
                    row.expanded && childRow.expanded && banks.expanded
                      ? h == 0
                        ? ' border-green-500 border-l-4'
                        : ' border-red-500 border-l-4'
                      : 'rowInvis'
                  "
                >
                  <div
                    class="flex justify-between"
                    [class]="
                      j % 2 == 0
                        ? h == 0
                          ? 'bg-gray-100 hover:bg-green-100'
                          : 'hover:bg-red-100'
                        : h == 0
                        ? 'hover:bg-green-100'
                        : 'hover:bg-red-100'
                    "
                  >
                    <div
                      [class]="
                        !row.expanded || !childRow.expanded
                          ? 'rowInvis'
                          : 'py-1  opacity-100 '
                      "
                      class="indent-12 whitespace-nowra font-bold w-1-6"
                      style="min-width: 176px; max-width: 176px"
                    >
                      {{ details.title }}
                    </div>
                    <div
                      [class]="
                        !row.expanded || !childRow.expanded
                          ? 'rowInvis'
                          : i == 0
                          ? h == 0
                            ? ' hover:bg-green-300 echCol '
                            : 'echCol hover:bg-red-300'
                          : h == 0
                          ? 'py-1 opacity-100 w-1-6 hover:bg-green-300'
                          : 'py-1 opacity-100 w-1-6  hover:bg-red-300'
                      "
                      *ngFor="let detail of details.data; index as i"
                      class="px-6 text-right whitespace-nowrap text-gray-800 font-bold w-1-6"
                      style="min-width: 150px"
                      (mouseover)="hovredCol = i"
                      (mouseout)="hovredCol = null"
                      (dblclick)="
                        seeDetails(
                          details.title,
                          row.title,
                          banks.title,
                          childRow.title,
                          details.Cat,
                          _level3[i],
                          i == 0
                        )
                      "
                    >
                      {{ detail | number: ".3-3":"fr" }}
                    </div>
                  </div>
                </div>
              </ng-container>
              <!-- endLevel -->
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
